import $ from "jquery";
import ky from "ky";

document.addEventListener("alpine:init", () => {
    Alpine.data("authPopup", () => ({
        open: false,
        init() {
            if (typeof alpineData.auth_login_selectors !== "undefined") {
                const selectors = alpineData.auth_login_selectors.split(",");
                selectors.forEach((element) =>
                    $(document).on("click", element, (event) => {
                        event.preventDefault();

                        this.toggleAuth(true);
                    }),
                );
            }

            $(this.$refs.auth).on("submit", "form.login-form", (event) => {
                event.preventDefault();

                this.login(event);
            });
            $(this.$refs.auth).on("submit", "form.register-form", (event) => {
                event.preventDefault();

                this.register(event);
            });
        },
        toggleAuth(open) {
            this.open = open;
        },
        async login(event) {
            try {
                const popup = $(this.$refs.auth);
                $(document).trigger("wpsoup/woocommerce/auth_popup/before_login", [popup, event.currentTarget]);

                this.blockElements();

                const formData = new FormData(event.currentTarget);
                formData.append("action", "wpsoup/woocommerce/auth_popup/login");

                const response = await ky
                    .post(frameworkGlobal.ajaxurl, {
                        body: formData,
                    })
                    .json();
                if (response.success) {
                    if (response.data?.action?.redirect_to !== "undefined") {
                        window.location.href = response.data.action.redirect_to;
                        return;
                    }
                }

                this.addMessage(response.data.message, response.success ? "success" : "error", "form.login-form");

                $(document).trigger("wpsoup/woocommerce/auth_popup/after_login", [
                    popup,
                    event.currentTarget,
                    response,
                ]);
            } catch (error) {
                this.addMessage(alpineData.auth_default_error_message, "error", "form.login-form");
            } finally {
                this.unblockElements();
            }
        },
        async register(event) {
            try {
                const popup = $(this.$refs.auth);
                $(document).trigger("wpsoup/woocommerce/auth_popup/before_register", [popup, event.currentTarget]);

                this.blockElements();

                const formData = new FormData(event.currentTarget);
                formData.append("action", "wpsoup/woocommerce/auth_popup/register");

                const response = await ky
                    .post(frameworkGlobal.ajaxurl, {
                        body: formData,
                    })
                    .json();
                if (response.success) {
                    if (response.data?.action?.redirect_to !== "undefined") {
                        window.location.href = response.data.action.redirect_to;
                        return;
                    }
                }

                this.addMessage(response.data.message, response.success ? "success" : "error", "form.register-form");

                $(document).trigger("wpsoup/woocommerce/auth_popup/after_register", [
                    popup,
                    event.currentTarget,
                    response,
                ]);
            } catch (error) {
                this.addMessage(alpineData.auth_default_error_message, "error", "form.register-form");
            } finally {
                this.unblockElements();
            }
        },
        addMessage(message, type = "success", form = "form.login-form") {
            if (message) {
                const elem = $("<div/>", {
                    class: "message " + type,
                }).html(message);

                if ($(".message").length) {
                    $(".message").replaceWith(elem);
                } else {
                    $(this.$refs.auth)
                        .find((form ? form + " " : "") + "[type='submit']")
                        .before(elem);
                }
            }
        },
        blockElements() {
            if ($(".message").length) {
                $(".message").remove();
            }

            let popup = this.$refs.auth;
            if (!popup) {
                return;
            }

            const loadingIcon = '<iconify-icon class="iconify icon-spin icon-2x" icon="fas:spinner"></iconify-icon>';
            popup = $(popup);
            popup.find(".offcanvas-inner").blockElement({
                html: loadingIcon,
            });
        },
        unblockElements() {
            let popup = this.$refs.auth;
            if (!popup) {
                return;
            }

            popup = $(popup);
            popup.find(".offcanvas-inner").unblockElement();
        },
    }));
});
